// Environments that must NOT report to the Sentry cloud (non-deployed).
// Keeping localhost/e2e out of the cloud avoids cluttering Sentry and burning
// quota with events that have no value from local development or test runs.
const NON_REPORTING_ENVIRONMENTS = ["localhost", "e2e"];

/**
 * Whether the app should send events to the Sentry cloud (DSN) for the given
 * environment. Cloud reporting is disabled for non-deployed environments
 * (localhost, e2e). An unset/unknown environment keeps cloud reporting ON so a
 * misconfigured deployed build still reports. Matching is case-insensitive.
 */
export function isSentryCloudReportingEnabled(appEnv?: string): boolean {
  return !NON_REPORTING_ENVIRONMENTS.includes((appEnv ?? "").toLowerCase());
}
